import { Observable } from '@legendapp/state'
import { useObservable } from '@legendapp/state/react'
import { createContext, PropsWithChildren, useContext } from 'react'

interface SidebarContext {
  state$: Observable<State$>
}

interface State$ {
  thisMenuOpened?: string
}

const Context = createContext<SidebarContext | null>(null)

const Provider = ({ children, ...props }: PropsWithChildren<SidebarContext>) => {
  return (
    <Context.Provider value={props}>
      {children}
    </Context.Provider>
  )
}

const useSidebarContext = () => {
  const context = useContext(Context)

  if (context === null) {
    throw new Error('useSidebarContext')
  }

  return context
}

const useSidebarState = () => {
  return useObservable<State$>({ thisMenuOpened: undefined })
}

export const ConsoleSidebar = {
  Provider,
  useSidebarContext,
  useSidebarState,
}
